import CxltToastr from 'cxlt-vue2-toastr';
import VueLocalStorage from 'vue-ls';
import VueSessionStorage from 'vue-sessionstorage';

Vue.use(CxltToastr, {
    position: 'top right',
    closeButton: true,
    showDuration: 2000,
    hideDuration: 2000,
    timeOut: 5000
});
Vue.use(VueLocalStorage);
Vue.use(VueSessionStorage);



// WEBPACK FOOTER //
// ./resources/assets/js/plugins.js